import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import { getUserRoleDisplayName } from '../../utils/permissionUtils';
import AccessDenied from '../access-denied/AccessDenied';

interface RoutePermissionGuardProps {
  requiredPermission: 'canEditPractices' | 'canEditProviders' | 'canEditInsurance';
  children: React.ReactNode;
}

export const RoutePermissionGuard: React.FC<RoutePermissionGuardProps> = ({
  requiredPermission,
  children,
}) => {
  const { permissions, isReady } = usePermissions();

  if (!isReady) {
    return null; // Wait for permissions to load
  }

  // Check if user has the required permission or is admin
  if (permissions[requiredPermission] || permissions.isAdmin) {
    return <>{children}</>;
  }

  // User doesn't have permission - show access denied screen
  const userRoleDisplay = getUserRoleDisplayName();
  const permissionGroup = permissions.permissionGroup || 'No specific permissions';

  return (
    <AccessDenied
      userRole={userRoleDisplay}
      permissionGroup={permissionGroup}
    />
  );
};
